<template>
  <Loading v-if="!list || !listVersions || listVersions.length == 0" />
  <vs-tabs v-else position="left" class="tabs-shadow-none mt-2">
    <vs-tab icon-pack="feather" icon="icon-info" label="General info">
      <div class="lists-view-tab">
        <list-general
          :list="list"
          @update:list="save"
          :availableCategories="availableCategories"
          :availableAreas="availableAreas"
          :isEditable="isEditable"
          :isNewestVersion="isNewestVersion"
          @publish="publish"
          @createNewVersion="createNewVersion"
          @routeToNewest="routeToNewestVersion"
        />
      </div>
    </vs-tab>

    <vs-tab icon-pack="feather" icon="icon-activity" label="Questions">
      <div class="lists-view-tab">
        <list-questions
          :list="list"
          @update:list="save"
          :availableCategories="availableCategories"
          :availableAreas="availableAreas"
          :isEditable="isEditable"
          :isNewestVersion="isNewestVersion"
          @publish="publish"
        />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import ListGeneral from "./ListGeneral.vue";
import ListQuestions from "./ListQuestions.vue";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    ListGeneral,
    ListQuestions
  },
  data() {
    return {};
  },
  async created() {
    const listId = this.$route.params.id;
    const activeCountry = this.$store.getters["venues/activeCountry"];
    await this.$store.dispatch("lists/getList", listId);
    await this.$store.dispatch("lists/getAvailableCategories", { listType: this.list.type, country: activeCountry.id });
    await this.$store.dispatch("lists/getAvailableAreas", { listType: this.list.type, country: activeCountry.id });
    await this.$store.dispatch("lists/getListsByType", { listType: this.list.type, country: activeCountry.id });
    console.log("Working on list", this.list);
  },
  methods: {
    async save() {
      try {
        this.$vs.loading();
        console.log("Saving list", this.list);
        await this.$store.dispatch("lists/saveList", this.list);
        this.$vs.notify({
          color: "success",
          title: "Updated",
          text: "Succesfully updated"
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not update",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async publish() {
      try {
        this.$vs.loading();
        console.log("publishing list list", this.list);
        await this.$store.dispatch("lists/publishList", this.list.id);
        this.$vs.notify({
          color: "success",
          title: "Published",
          text: "Succesfully published list"
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not publish",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    async createNewVersion() {
      try {
        this.$vs.loading();
        console.log("Creating new version for list", this.list);
        var newListId = await this.$store.dispatch("lists/createNewVersion", { listType: this.list.type, country: this.activeCountry.id });
        this.$vs.notify({
          color: "success",
          title: "New version",
          text: "Succesfully created new version of list"
        });

        // Route to new list
        this.$router
          .push({
            name: "manage-list",
            params: { id: newListId }
          })
          .catch(e => {
            console.log("Create new list routing error", e);
          });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Could not create new version",
          text: err
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    routeToNewestVersion() {
      this.$router
        .push({
          name: "manage-list",
          params: { id: this.newestVersionId }
        })
        .catch(e => {
          console.log("Create new list routing error", e);
        });
    }
  },
  computed: {
    ...mapGetters({
      list: "lists/list",
      availableCategories: "lists/availableCategories",
      availableAreas: "lists/availableAreas",
      listVersions: "lists/listsByType",
      activeCountry: "venues/activeCountry"
    }),

    newestVersionId() {
      return _.maxBy(this.listVersions, "version").id;
    },

    newestVersion() {
      return _.maxBy(this.listVersions, "version").version;
    },

    isEditable() {
      return this.isNewestVersion && !this.list.isPublished && this.hasPermission("vp.life.lists.edit");
    },

    isNewestVersion() {
      return this.newestVersion === this.list.version;
    }
  }
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
